import { AlertTriangle, Phone } from "lucide-react";

const RED = "var(--st-red)";

export const Tel = ({ phone, testid }) => (phone ? (
  <a href={`tel:${phone.replace(/[^\d+]/g, "")}`} className="inline-flex min-h-[44px] items-center gap-1.5 font-semibold text-[rgb(var(--glow-family))] underline underline-offset-2" data-testid={testid}>
    <Phone className="h-4 w-4" /> {phone}
  </a>
) : null);

export const SevereBadge = ({ testid }) => (
  <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.12em]" style={{ background: `rgba(${RED},0.16)`, color: `rgb(${RED})` }} data-testid={testid}>
    <AlertTriangle className="h-3 w-3" /> Severe allergy
  </span>
);

const Row = ({ label, children }) => (children ? <div><dt className="text-[10px] font-black uppercase tracking-[0.14em] text-q-faint">{label}</dt><dd className="mt-0.5 text-sm text-q-text">{children}</dd></div> : null);

export function CardBody({ card, keyId, sitter }) {
  const s = card.sitter_notes || {};
  return (
    <dl className="space-y-3">
      <Row label="Allergies">{card.allergies.length ? card.allergies.map((a, n) => (
        <p key={n} data-testid={`allergy-${keyId}-${n}`}><b style={{ color: a.severity === "Severe" ? `rgb(${RED})` : undefined }}>{a.allergen}</b> · {a.severity}{a.note ? ` · ${a.note}` : ""}</p>
      )) : null}</Row>
      <Row label="Conditions">{card.conditions}</Row>
      <Row label="Medications">{card.medications.length ? card.medications.map((m, n) => <p key={n} data-testid={`med-${keyId}-${n}`}>{[m.name, m.dose, m.when].filter(Boolean).join(", ")}</p>) : null}</Row>
      <Row label="Blood type">{card.blood_type !== "Unknown" ? card.blood_type : null}</Row>
      <Row label="Date of birth">{card.dob}</Row>
      <Row label="Phone">{card.phone ? <Tel phone={card.phone} testid={`phone-${keyId}`} /> : null}</Row>
      <Row label="Doctors">{card.doctors.length ? card.doctors.map((d, n) => <p key={n}>{[d.role, d.name].filter(Boolean).join(": ")} <Tel phone={d.phone} testid={`doctor-phone-${keyId}-${n}`} /></p>) : null}</Row>
      {!sitter && <Row label="Insurance">{card.insurance}</Row>}
      <Row label="Bedtime">{s.bedtime}</Row>
      <Row label="Screen rules">{s.screen}</Row>
      <Row label="Food rules">{s.food}</Row>
    </dl>
  );
}

export function FamilyBody({ family }) {
  return (
    <div className="space-y-3" data-testid="family-section">
      <div className="flex flex-wrap gap-x-6">
        {family.fixed.map((f) => <p key={f.label} className="font-bold text-q-text" data-testid={`fixed-${f.label.replace(/\s+/g, "-").toLowerCase()}`}>{f.label}: <Tel phone={f.phone} testid={`fixed-phone-${f.label.replace(/\s+/g, "-").toLowerCase()}`} /></p>)}
      </div>
      {family.address && <p className="text-sm text-q-text" data-testid="family-address"><span className="text-q-faint">Home: </span>{family.address}</p>}
      {family.contacts.length > 0 && (
        <div data-testid="family-contacts">
          <p className="text-[10px] font-black uppercase tracking-[0.14em] text-q-faint">Emergency contacts</p>
          {family.contacts.map((c, n) => <p key={n} className="text-sm text-q-text">{c.name}{c.relationship ? ` (${c.relationship})` : ""} <Tel phone={c.phone} testid={`contact-phone-${n}`} /></p>)}
        </div>
      )}
      {family.hospital?.name && (
        <div data-testid="family-hospital">
          <p className="text-[10px] font-black uppercase tracking-[0.14em] text-q-faint">Nearest hospital</p>
          <p className="text-sm text-q-text">{family.hospital.name}{family.hospital.address ? ` · ${family.hospital.address}` : ""} <Tel phone={family.hospital.phone} testid="hospital-phone" /></p>
        </div>
      )}
    </div>
  );
}
